import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';

function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isMobile && isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isMobile, isOpen]);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  const handlePageChange = () => {
    closeMenu();
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, 10);
  };

  const menuItems = [
    { href: "/#Price", label: "Меню" },
    { href: "/#Order", label: "Заказать" },
    { href: "/#Work", label: "Галерея" },
    { href: "/#Before", label: "Вопросы" },
    { href: "/#Feedback", label: "Отзывы" },
    { href: "/for-confectioners", label: "Для кондитеров" }
  ];

  return (
    <>
      <button 
        className={`burger-button ${isOpen ? 'open' : ''}`} 
        onClick={toggleMenu}
        aria-label="Меню"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div 
        className={`menu-overlay ${isOpen ? 'active' : ''}`} 
        onClick={closeMenu}
      />

      <nav className={`menu-nav ${isOpen ? 'open' : ''}`}>
        <ul className="menu-ul">
          {menuItems.map((item) => (
            <li key={item.href} className="li">
              {item.href === "/for-confectioners" ? (
                <Link 
                  className="a has-badge" 
                  to={item.href}
                  onClick={handlePageChange} 
                >
                  {item.label}
                  <span className="new-badge">Новое</span>
                </Link>
              ) : (
                <a 
                  className="a" 
                  href={item.href}
                  onClick={closeMenu}
                >
                  {item.label}
                </a>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
}

export default Navigation;